import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import FutureOfMentalHealth from './FutureOfMentalHealth';

export default function Blog() {
  return (
    <>
        <Navbar />
        <FutureOfMentalHealth />
        <Footer />
        <Copyright />
    </>
  )
}